export class UserSettings {
  sidePanelOpened: boolean;

  constructor(userSettings: Partial<UserSettings>) {
    Object.assign(this, userSettings);
  }
}
